const POPULATE_APP_DATA = "POPULATE_APP_DATA";
const TOGGLE_AUTOPLAY = "TOGGLE_AUTOPLAY";
const AUTOPLAY_INTERVAL = "3000";
const SELECT_ITEM = "SELECT_ITEM";
const ADD_ITEM = "ADD_ITEM";
const DELETE_ITEM = "DELETE_ITEM";
const UPDATE_ITEM = "UPDATE_ITEM";
const TOGGLE_CATEGORY = "TOGGLE_CATEGORY";
const POPULATE_CATEGORIES = "POPULATE_CATEGORIES";
const SELECT_SUBCAT = "SELECT_SUBCAT";
const TOGGLE_STOCK = "TOGGLE_STOCK";
const HANDLE_SORTED = "HANDLE_SORTED";


module.exports = {
    POPULATE_APP_DATA,
    TOGGLE_AUTOPLAY,
    AUTOPLAY_INTERVAL,
    SELECT_ITEM,
    ADD_ITEM,
    DELETE_ITEM,
    UPDATE_ITEM,
    TOGGLE_CATEGORY,
    POPULATE_CATEGORIES,
    SELECT_SUBCAT,
    TOGGLE_STOCK,
    HANDLE_SORTED
};


// WEBPACK FOOTER //
// ./src/constants/constants.js